/**
 * Podium accents for ranks 1–3; everything below gets the muted number.
 * Shared by the live scoreboard and the Teams roster (via `RankPill`) so a rank
 * reads the same everywhere it appears.
 */
export const PODIUM_CLASSES: Record<number, string> = {
  1: 'bg-amber-400/15 text-amber-600',
  2: 'bg-slate-400/15 text-slate-500',
  3: 'bg-orange-400/15 text-orange-600',
};
